import React from 'react';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import 'dayjs/locale/nb';
import 'dayjs/locale/es-mx';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/gu';
import 'dayjs/locale/hi';
import 'dayjs/locale/nl-be';
import 'dayjs/locale/tl-ph';
import 'dayjs/locale/pa-in';
import { createRoot } from 'react-dom/client';

import { App } from './App';

dayjs.extend(advancedFormat);

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(<App />);
});
